<span [innerHTML]="shownAgentValue$ | highlightText$: searchValue | async"> </span>
